import { render, staticRenderFns } from "./associated.vue?vue&type=template&id=c1a4583a&"
import script from "./associated.vue?vue&type=script&lang=ts&"
export * from "./associated.vue?vue&type=script&lang=ts&"
import style0 from "./associated.vue?vue&type=style&index=0&id=c1a4583a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports